var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"toast-animation"}},[(_vm.value)?_c('div',{staticClass:"toast"},[_c('div',{class:['toast-wrapper', _vm.bgClass]},[_c('p',[_vm._v(_vm._s(_vm.msg))])])]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }